export function checkExists<T>(
  obj: T | null | undefined, 
  lazyMessage: () => string = () => `Object expected to exist`
) : T {
  if (!obj) throw lazyMessage();
  return obj;
}